import { render, staticRenderFns } from "./send_mail.vue?vue&type=template&id=587f9d7c&scoped=true&"
import script from "./send_mail.vue?vue&type=script&lang=js&"
export * from "./send_mail.vue?vue&type=script&lang=js&"
import style0 from "./send_mail.vue?vue&type=style&index=0&id=587f9d7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587f9d7c",
  null
  
)

export default component.exports